import withStore, { TLoadingAwarePresenter, TPresentable } from "../withStore";
import Application from "../../Application";
import ShowErrorMessageInteractor from "../../interactor/notifications/ShowErrorMessageInteractor";
import { IFact } from "../../model/evaluation/Fact";
import GetFactsInteractor from "../../interactor/evaluation/GetFactsInteractor";
import CreateFactInteractor from "../../interactor/evaluation/CreateFactInteractor";
import ShowSuccessMessageInteractor from "../../interactor/notifications/ShowSuccessMessageInteractor";
import UpdateFactInteractor from "../../interactor/evaluation/UpdateFactInteractor";

export interface TFactsPresenter extends TLoadingAwarePresenter {
  facts: IFact[] | undefined;
}
export interface IFactsPresenter extends TFactsPresenter, TPresentable {
  getFacts(): Promise<void>;
  setFacts(facts: IFact[]): void;
  createFact(fact: IFact): void;
  updateFact(fact: IFact): void;
}

const defaultState: TFactsPresenter = {
  facts: []
};

const FactsPresenter = withStore<IFactsPresenter, TFactsPresenter>(
  ({ application, store, loader, translate }): IFactsPresenter => {
    const _store = store;
    const _application: Application = application;
    const state = _store.getState<TFactsPresenter>();

    loader.start("factsLoader");

    const setFacts = (facts: IFact[]) => {
      _store.update({ facts });
      loader.stop("factsLoader");
    };

    const getFacts = async () => {
      try {
        let facts = await _application.container
          .resolve<GetFactsInteractor>("getFacts")
          .execute();
        _store.update({ facts });
      } catch (error) {
        _application.container
          .resolve<ShowErrorMessageInteractor>("showErrorMessage")
          .execute((error as any).message);
      }
    };

    const createFact = async (fact: IFact) => {
      try {
        await _application.container
          .resolve<CreateFactInteractor>("createFact")
          .execute(fact);
        _application.container
          .resolve<ShowSuccessMessageInteractor>("showSuccessMessage")
          .execute(translate("facts_page.messages.create_fact_success"));
        await getFacts();
      } catch (error) {
        _application.container
          .resolve<ShowErrorMessageInteractor>("showErrorMessage")
          .execute((error as any).message);
      }
    };

    const updateFact = async (fact: IFact) => {
      try {
        await _application.container
          .resolve<UpdateFactInteractor>("updateFact")
          .execute(fact);
        _application.container
          .resolve<ShowSuccessMessageInteractor>("showSuccessMessage")
          .execute(translate("facts_page.messages.update_fact_success"));
        await getFacts();
      } catch (error) {
        _application.container
          .resolve<ShowErrorMessageInteractor>("showErrorMessage")
          .execute((error as any).message);
      }
    };

    return {
      ...state,

      store: _store,
      loader,
      application: _application,
      translate,
      getFacts,
      setFacts,
      createFact,
      updateFact
    };
  },
  defaultState
);

export default FactsPresenter;
